<template>
  <div class="order-details orderDetails">
    <div class="receiveInfo">
      <div class="box">
        <div class="header-title acea-row row-between-wrapper">
          <div class="row-middle">{{ orderInfo.fhdh }}</div>
          <div class="font-color-red">{{ status[orderInfo.status] }}</div>
        </div>
        <p class="mt-10">
          <span>{{ orderInfo.consignee_name }}</span>
          <span class="ml-20 phone">{{ orderInfo.consignee_phone }}</span>
        </p>
        <p class="address">
          {{ orderInfo.consignee_address }}
        </p>
      </div>
    </div>
    <div class="address-line">
      <img src="@assets/images/line.jpg" />
    </div>
    <div>
      <!-- <van-cell :border="false" title="物流单号：" v-model="orderInfo.ship_id"></van-cell> -->
      <van-cell
        :border="false"
        title="订单编号："
        v-model="orderInfo.order_id"
      ></van-cell>
      <van-cell
        :border="false"
        title="订单日期："
        v-model="orderInfo.create_time"
      ></van-cell>
      <van-cell
        :border="false"
        title="物流公司："
        v-model="orderInfo.freight_name"
      ></van-cell>
      <van-cell
        :border="false"
        title="物流价格："
        v-model="orderInfo.freight_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="物流备注："
        v-model="orderInfo.freight_remarks"
      ></van-cell>
    </div>
    <div>
      <div class="wrapper">
        <div class="item acea-row row-between">
          <div>配送方式：</div>
          <div class="conter">
            发货
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>快递公司：</div>
          <div class="conter">{{ orderInfo.freight_name || "" }}</div>
        </div>
        <div
          class="item acea-row row-between"
          @click="$router.push({ path: '/order/logistics/' + orderInfo._ID })"
        >
          <div>物流信息：</div>
          <div class="conter">点击查看物流信息</div>
        </div>
      </div>
    </div>
    <div class="infoBox">
      <p class="pro-count padding20 bor-b">
        <span>SPU:{{ orderInfo.total_spu }}</span>
        <span>SKU:{{ orderInfo.total_sku }}</span>
        <span>商品数:{{ orderInfo.total_num }}</span>
      </p>
      <ul class="proList">
        <li class="proItem">
          <van-row class="size-info">
            <van-col span="2" style="border-right:1px solid #ccc">
              <p class="bor-c">
                序号
              </p>
            </van-col>
            <van-col span="3">
              <p class="bor-c">
                图片
              </p>
            </van-col>
            <van-col span="19">
              <van-row>
                <van-col span="12">
                  <p class="pro-name">品名/suk</p>
                </van-col>
                <van-col span="4">
                  <p>下单数</p>
                </van-col>
                <van-col span="4">
                  <p>发货数</p>
                </van-col>
                <van-col span="4">
                  <p>未发数</p>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
          <van-row
            span="2"
            v-for="(pro, index) in orderInfo.detail"
            :key="index"
            :class="[{ pink: index % 2 == 0 }, 'size-info']"
          >
            <van-col class="text-c" span="2">
              <p style="height: 0.8rem; line-height: 0.8rem;border-right:1px solid #ccc">
                {{ index + 1 }}
              </p>
            </van-col>
            <van-col span="3">
              <p style="height: 0.8rem; line-height: 0.8rem" class="bor-c">
                <img :src="pro.image" object-fit="cover" alt />
              </p>
            </van-col>
            <van-col span="19">
              <van-row>
                <van-col span="12">
                  <p
                    style="height: 0.8rem; line-height: 0.8rem"
                    class="pro-name"
                  >
                    {{ pro.name + "/" + pro.suk }}
                  </p>
                </van-col>
                <van-col span="4">
                  <p class="text-c" style="height: 0.8rem; line-height: 0.8rem">
                    {{ pro.order_num }}
                  </p>
                </van-col>
                <van-col span="4">
                  <p class="text-c" style="height: 0.8rem; line-height: 0.8rem">
                    {{ pro.shipments_num }}
                  </p>
                </van-col>
                <van-col span="4">
                  <p class="text-c" style="height: 0.8rem; line-height: 0.8rem">
                    {{ pro.no_shipments_num }}
                  </p>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getDispatchDetail } from "@api/order";
import { formatPrice } from "@utils";
export default {
  data() {
    return {
      sizeList: [{}],
      orderInfo: {
        add_time: "",
        consignee_address: null,
        consignee_name: null,
        consignee_phone: null,
        customer_id: "5",
        customer_mark: null,
        customer_name: "",
        customer_phone: "",
        detail: [{},{}],
        discount_price: "0.00",
        freight_name: "",
        freight_pay_price: null,
        freight_price: "0.00",
        freight_remarks: "",
        id: "",
        is_confirm: "0",
        offline_pay_price: "0.00",
        on_line_pay_price: "0.00",
        order_id: "",
        order_time: "",
        pay_status: "0",
        pay_time: null,
        pay_type: "0",
        status: "0",
        total_num: "0",
        total_pay_price: "0.00",
        total_price: "0.00",
        total_sku: "0",
        total_spu: "0"
      },
      status: {
        "0": "待收货",
        "1": "已发货",
        "2": "已收货"
      },
      orderId: ""
    };
  },
  created() {
    console.log(this.$route);
    if (this.$route.query && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      console.log(this.$route.query);
      // this.getOrderDetal();
    }
    this.getOrderDetal();
  },
  methods: {
    getOrderDetal() {
      const { orderId, isShow } = this;
      getDispatchDetail(orderId)
        .then(res => {
          // console.log(res.data);
          formatPrice(res.data);
          this.orderInfo = res.data;
        })
        .catch(e => {
          console.log(e);
          this.$dialog.toast({ mes: e.msg });
          // this.orderInfo = e.data.data;
        });
    }
    // goBill() {
    //   this.$router.push({
    //     name: "dispatchBill"
    //   });
    // }
  }
};
</script>
<style>
.receiveInfo {
  padding: 0.2rem 0.3rem !important;
}
.header-title {
  height: 0.84rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.28rem;
  color: #868686;
  background: #eeeeee;
}
.receiveInfo .box {
  border: 1px solid rgb(245, 245, 245);
  box-shadow: 2px 2px 0px #eeeeee;
}
.box .address {
  font-size: 0.28rem;
}
.phone {
  color: #868686;
}
.address-line {
  overflow: hidden;
  background: white;
}
.address-line img {
  vertical-align: top;
}
.pro-count {
  background: red;
  color: white;
}
.pink {
  background: #f5f5f5;
}
.text-c {
  text-align: center;
}
</style>
